import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom"; // ✅ Correct import
import { useTheme } from "../context/ThemeContext";
import { borderRadius, spacing } from "../utils/tokens";
import Typography from "./Typography";
import { ArrowDown, ArrowUp } from "@phosphor-icons/react";
import wsjLogo from "../assets/logos/wsj-logo.svg"; // Import WSJ Logo
import Divider from "./Divider";


function Ticker ( { stockSymbol, percentage, delta } ){
    const { theme } = useTheme();
    const navigate = useNavigate();

    const formattedPercentage = !isNaN(parseFloat(percentage)) ? Math.abs(parseFloat(percentage)).toFixed(2) : "0.00";

    const styles = {
        container: {
            display: "flex",
            gap: spacing.xxxs,
            width: "100%",
            height: "100%",
            color: theme.colors.text,
            padding: spacing.xxxs,
            boxSizing: "border-box",
            width: "fit-content",
            alignItems: "center",
        },
        tickerContainer:{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            gap: spacing.xs,
            padding: "12px 12px",
            width: "fit-content",
            height: "28px",
            backgroundColor: theme.colors.fillSecondary,
            // backgroundColor: delta ? theme.colors.positiveFillSecondary : theme.colors.negativeFillSecondary,
            boxSizing: "border-box",
            borderRadius: borderRadius.s,
        },
        dataContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: spacing.xxs,
            width: "fit-content",
        },
        deltaIcon: {
            display: "flex",
            alignItems: "center",
        },
    };

    return (
        <div style={styles.container}>
            <div style={styles.tickerContainer} onClick={() => {navigate(`/company/${stockSymbol}`);}} >
                <Typography variant="supportingCaption" type="editorial" 
                    // style={{ color: delta ? theme.colors.positiveFillPrimary : theme.colors.negativeFillPrimary, }}
                    style={{ color: theme.colors.contentSecondary }}
                >
                    {stockSymbol}
                </Typography>
                <div style={styles.dataContainer}>
                    <div style={styles.deltaIcon}>
                        {delta ? <ArrowUp size={16} color="green" /> : <ArrowDown size={16} color="red" />}
                    </div>
                    <Typography 
                        variant="supportingCaption" 
                        type="editorial" 
                        style={{ 
                            color: delta ? theme.colors.positiveFillPrimary : theme.colors.negativeFillPrimary,
                        }}
                    >
                        {formattedPercentage}%
                    </Typography>
                </div>
            </div>
        </div>
    );
}

export default Ticker;